// extracted by mini-css-extract-plugin
export default {"answerInput":"startQuiz_answerInput__+RztL","buttonSubmit":"startQuiz_buttonSubmit__P-Dzh"};